package pl.michal_cyran.portfolio.core

import com.varabyte.kobweb.compose.ui.graphics.Color


object BadgeColors {
    val gold = Color.rgb(0xfb, 0x92, 0x3c)
    val red = Color.rgb(0xf8, 0x71, 0x71)
    val cyan = Color.rgb(0x22, 0xd3, 0xee)
    val green = Color.rgb(0x4a, 0xde, 0x80)
    val pink = Color.rgb(0xc0, 0x84, 0xfc)
    val blue = Color.rgb(0x60, 0xa5, 0xfa)
    val magenta = Color.rgb(0xec, 0x48, 0x99)
}

